import { IQueryConditionHandler } from './iquerycondition.handler';
import { QueryCondition } from '../../entity/querycondition';
import { CompareType } from '../enum/compare-type.enum';
import { ValueType } from '../enum/value-type.enum';
import { RelationType } from '../enum/relation-type.enum';
import { ComboLookUpValue } from '../../entity/conditionvalue/combolookupvalue';

export class ComboLookUpHandler implements IQueryConditionHandler {
  convert(qc: QueryCondition) {
    const cluv = (qc.value as ComboLookUpValue);
    if (cluv.value.length == 0 || !cluv.valueField) {
      return [];
    } else {
      const arr = [];
      cluv.getOriginalValue().split(',').forEach((id) => {
        id && arr.push({
          'FilterField': qc.fieldCode,
          'Compare':  CompareType.Equal,
          'Value': id,
          'Relation':  RelationType.Or,
          'Expresstype': ValueType.Value
        });
      });
      if (arr.length > 0) {
        arr[0]['Lbracket'] = '(';
        arr[arr.length -1]['Rbracket'] = ')';
        arr[arr.length - 1]['Relation'] = RelationType.And;
        return arr;
      } else {
        return [];
      }
    }
  }
}
